import { Component } from '@angular/core'
import { BaseEventListComponent } from '../event-shared/base-event-list.component'
import { AuthService } from '@shared/services/auth.service'
import { EventService } from '@shared/services/event.service'
import { AttendeesService } from '@shared/services/attendees.service'
import { LeaderboardService } from '@shared/services/leaderboard.service'
import { LeaderboardOwnRow } from '@shared/models/leaderboard.model'
import { formatHours } from '@shared/const/hours/hours-formatter.const'
import { EventModel } from '@shared/models/event.model'
import { PublicPageTitleService } from '@public/app/services/public-page-title.service'
import { LoadingIndicatorService } from '@public/app/services/loading-indicator.service'
import { ToastService } from '@public/app/services/toast.service'

@Component({
  selector: 'app-my-event-list',
  templateUrl: './my-event-list.component.html',
  styleUrls: ['./my-event-list.component.scss'],
  standalone: false,
})
export class MyEventListComponent extends BaseEventListComponent {
  pageTitle = 'Eseményeim'
  volunteering: LeaderboardOwnRow | null = null
  formatHours = formatHours
  constructor(
    authService: AuthService,
    eventService: EventService,
    attendeesService: AttendeesService,
    publicPageTitleService: PublicPageTitleService,
    loadingIndicatorService: LoadingIndicatorService,
    toastService: ToastService,
    private leaderboardService: LeaderboardService
  ) {
    super(authService, eventService, attendeesService, publicPageTitleService, loadingIndicatorService, toastService)
  }

  ngOnInit(): void {
    super.ngOnInit()
    this.leaderboardService.getLeaderboard().subscribe({
      next: leaderboard => (this.volunteering = leaderboard.me),
      error: () => (this.volunteering = null),
    })
  }

  protected transformEvents(events: EventModel[]): EventModel[] {
    return events.filter(e => e.isRegistered)
  }

  protected updateEventListAfterUnregister(event: EventModel): void {
    this.eventList = this.eventList.filter(e => e.id !== event.id)
  }
}
